import { Reveal, Eyebrow } from "@/components/Reveal";
import { ToothIcon } from "@/components/icons";

const PHOTOS = [
  { src: "/gallery/01-front.webp", caption: "Clinic Front & Main Signboard" },
  { src: "/gallery/02-entrance.webp", caption: "Clinic Entrance & Direction Board" },
  { src: "/gallery/03-passage.webp", caption: "Main Entrance Passage" },
  { src: "/gallery/04-reception.webp", caption: "Reception & Waiting Area" },
  { src: "/gallery/05-treatment.webp", caption: "Dental Treatment Room" },
  { src: "/gallery/06-treatment-2.webp", caption: "Treatment Room — Second Angle" },
];

const GalleryTile = ({ photo, index }) => (
  <Reveal delay={(index % 3) * 0.1}>
    <figure
      data-testid={`gallery-tile-${index + 1}`}
      className="relative aspect-[4/5] overflow-hidden rounded-2xl border border-[#063A2F]/10 bg-white shadow-[0_8px_30px_rgba(6,58,47,0.05)] ring-1 ring-inset ring-[#D4AF37]/20 transition-[transform,box-shadow] duration-300 hover:-translate-y-1 hover:shadow-lg"
    >
      {photo ? (
        <>
          <img
            src={photo.src}
            alt={`Smart Dental Clinic — ${photo.caption}`}
            loading="lazy"
            decoding="async"
            className="h-full w-full object-cover"
          />
          <figcaption className="absolute bottom-3 left-3 rounded-full bg-[#FDFCF8]/95 px-3.5 py-1.5 text-[11px] font-bold text-[#063A2F] shadow-sm">
            {photo.caption}
          </figcaption>
        </>
      ) : (
        <>
          <ToothIcon className="absolute left-1/2 top-1/2 h-24 w-24 -translate-x-1/2 -translate-y-1/2 text-[#14B8A6]/15" />
          <figcaption className="absolute bottom-4 left-5">
            <span className="font-display block text-xl text-[#063A2F]">
              Clinic Photo {String(index + 1).padStart(2, "0")}
            </span>
            <span className="text-[10px] font-bold uppercase tracking-widest text-[#A8842C]">
              Coming soon
            </span>
          </figcaption>
        </>
      )}
    </figure>
  </Reveal>
);

export const Gallery = () => (
  <section id="gallery" data-testid="gallery-section" className="bg-[#F2FBF7] py-24 lg:py-32">
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <Reveal className="max-w-2xl">
        <Eyebrow>Clinic Gallery</Eyebrow>
        <h2 className="font-display mt-5 text-4xl tracking-tight text-[#063A2F] sm:text-5xl">
          A look inside <span className="italic text-[#0D9488]">the clinic</span>
        </h2>
        <p className="mt-5 text-base leading-relaxed text-[#475569]">
          Real photographs of Smart Dental Clinic — from our signboard on
          Bahadurpura Police Station Road to our reception and treatment rooms.
        </p>
      </Reveal>

      <div className="mt-14 grid grid-cols-2 gap-4 lg:grid-cols-3 lg:gap-5">
        {PHOTOS.map((p, i) => (
          <GalleryTile key={i} photo={p} index={i} />
        ))}
      </div>
    </div>
  </section>
);
